import { Meta } from "@/shared/components";
import { AdminDashboard } from "@/admin/widgets";

export const DashboardPage = () => {
  return (
    <>
      <Meta title="Панель управления" />
      <AdminDashboard />
    </>
  );
};
